type ArrayRemover<T> = (item: T) => void;

// Filter cannot be used reactively as it returns a new array, so instead
// we make a simple wrapper around splice for the reactive([]) use case
export function useRemoveFromArray<T>(arr: T[]): ArrayRemover<T> {
	return (item: T) => arr.splice(arr.indexOf(item), 1);
}
